import { render } from "./AdminWebhooksView.vue?vue&type=template&id=ca122f0a&scoped=true"
import script from "./AdminWebhooksView.vue?vue&type=script&lang=js"
export * from "./AdminWebhooksView.vue?vue&type=script&lang=js"

import "./AdminWebhooksView.vue?vue&type=style&index=0&id=ca122f0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca122f0a"]])

export default __exports__